module.exports = __webpack_public_path__ + "static/img/logo_station.3eec4ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_station.png
// module id = TUHv
// module chunks = 123